import React, { useCallback } from 'react';

import DataTable from '../../../components/DataTable';
import { useParams } from 'react-router';
import useUserRecordsTableData from '../../../hooks/useUserRecordsTableData';

const UserRecordsTab: React.FC<{}> = () => {
  const { userId } = useParams<{ userId: string }>();

  const getQueryOptions = useCallback(() => {
    return {
      where: {
        userId: { equals: userId },
      },
    };
  }, [userId]);

  const tableData = useUserRecordsTableData({
    queryOptions: getQueryOptions(),
  });

  return <DataTable {...tableData} />;
};

export default React.memo(UserRecordsTab);
